<template>
  <div class="home">
    <Loading :loading="this.loading"></Loading>
    <div v-show="!loading" class="itemContainer">
      <div v-if="inspectionFlag">
        <CarCareTopInspectionAfter v-bind:car="car" v-bind:Manufacturer="Manufacturer" v-bind:detail="detail" v-bind:ssInfo="ssInfo"  v-bind:tsId="tsId" v-bind:nativeData="nativeData" v-bind:profileInfo="profileInfo"></CarCareTopInspectionAfter>
      </div>
      <div v-else>
        <CarCareTopInspectionBefore v-bind:car="car" v-bind:ssInfo="ssInfo" v-bind:profileInfo="profileInfo" v-bind:tsId="tsId" v-bind:nativeData="nativeData" v-bind:detail="detail"></CarCareTopInspectionBefore>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import inspection from '../store/Api/inspection'
import car from '@/store/Api/car'
import profileApi from '@/store/Api/Common/profile'
import ssApi from '@/store/Api/Common/ss'
import manufacturersApi from '../store/Api/manufacturers'
import CarCareTopInspectionBefore from '@/views/CarCareTopInspectionBefore.vue'
import CarCareTopInspectionAfter from '@/views/CarCareTopInspectionAfter.vue'
import modal from '../assets/modal'
import Loading from '@/views/Loading.vue'

export default {
  data () {
    return {
      loading: true,
      tsId: 0,
      inspectionID: 0,
      inspectionFlag: true,
      carFlag: true,
      profileInfo: [],
      ssInfo: [],
      Manufacturer: {},
      coupon: {
        name: '',
        shortDescription: '利用クーポン無し',
        usableStartAt: '',
        usableEndAt: '',
        description: ''
      }
    }
  },
  methods: {
    ...mapActions('INSPECTION', [
      'setInspection',
      'setDetail'
    ]),
    ...mapActions('CAR', [
      'setCar'
    ]),
    setProfileInfo (profileInfo) {
      this.profileInfo = profileInfo
    },
    setSsInfo (ssInfo) {
      this.ssInfo = ssInfo
    },
    openErrorModal (message) {
      modal.alert(message)
    }
  },
  computed: {
    ...mapGetters('INSPECTION', [
      'inspection',
      'detail'
    ]),
    ...mapGetters('CAR', [
      'car'
    ]),
    nativeData: function () {
      const getData = {}
      // ネイティブから取得したデータを格納する。
      getData.tsid = this.$route.query.tsid
      getData.popinfoid = this.$route.query.popinfoid
      getData.otoken = this.$route.query.otoken
      return getData
    }
  },
  async mounted () {
    // 戻るボタンの出し分け
    this.appDisplayBack(false)
    let isApiError = false
    // profile情報マスタ取得。
    await profileApi.get(this.nativeData.tsid, this.nativeData.otoken).then(res => {
      this.setProfileInfo(res.data.body)
    }).catch(e => {
      console.log('profile-error')
      console.log(e.message)
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })
    // inspection(予約)データ取得
    await inspection.get(this.$route.query.tsid).then(res => {
      this.setInspection(res.data)
    }).catch(e => {
      console.log('inspection-error')
      console.log(e.message)
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    if (this.inspection.inspections.length !== 0) this.setDetail((await inspection.getDetail(this.inspection.inspections[0].id)).data)
    if (this.detail[0].id !== '') {
      // 車名（メーカーを取得する）
      await manufacturersApi.getDetail(this.detail[0].inspection_estimate.manufacturer_id).then(res => {
        this.Manufacturer = res.data.manufacturer
      }).catch(e => {
        console.log('manufactuer-error')
        console.log(e.message)
        if (!isApiError) {
          this.openErrorModal('エラーが発生しました。')
          isApiError = true
        }
      })
    } else {
      this.inspectionFlag = false
    }
    // SS情報マスタ取得。
    // 予約がある場合
    if (this.inspectionFlag) {
      await ssApi.get(this.detail[0].inspection_estimate.ss_code).then(res => {
        this.setSsInfo(res.data.body.ss_info)
      }).catch(e => {
        console.log('ss-error')
        console.log(e.message)
        if (!isApiError) {
          this.openErrorModal('エラーが発生しました。')
          isApiError = true
        }
      })
    // 予約がない場合
    } else {
      // ベストMYSSが存在している場合
      if (this.profileInfo.best_myss.length !== 0) {
        await ssApi.get(this.profileInfo.best_myss.code).then(res => {
          this.setSsInfo(res.data.body.ss_info)
        }).catch(e => {
          console.log('ss-error')
          console.log(e.message)
          if (!isApiError) {
            this.openErrorModal('エラーが発生しました。')
            isApiError = true
          }
        })
      }
    }
    // car(車検証)データ取得
    if (!(await car.get(this.nativeData.tsid)).data.car[0]) this.carFlag = false
    if (this.carFlag === true) {
      this.setCar((await car.get(this.nativeData.tsid)).data.car[0])
      // // // 車検満了日
      this.car.expiryGengo = 0
      // // 初度登録年月
      this.car.firstRegistrationGengo = 0
      this.car.oil_exchanged = true
      // // TODO
      this.car.coupon = this.coupon
      this.car.coupon_id = ''
      this.car.coupon_fee = 0
      this.car.bestmy_ss_id = ''
      this.car.bestmy_ss_prefecture = ''
      this.car.bestmy_ss_factory_type_flag = ''
    }
    // イベントトラッキング
    // 予約がある場合
    if (this.inspectionFlag) {
      if (this.detail[0].id !== '') {
        // 申し込み
        if (this.detail[0].status_code === 1) {
          this.nativePVset('CARCARE_MOSIKOMI')
        }
        // 日程確定
        if (this.detail[0].status_code === 2) {
          this.nativePVset('CARCARE_NITTEIKAKUTEI')
        }
        // お預かり
        if (this.detail[0].status_code === 3) {
          this.nativePVset('CARCARE_AZUKARITYU')
        }
        // 車検完了
        if (this.detail[0].status_code === 4) {
          this.nativePVset('CARCARE_KANRYO')
        }
        // 支払い完了（現金払い）
        if (this.detail[0].status_code === 5 && this.detail[0].payment_method_code === 2) {
          this.nativePVset('CARCARE_CASH')
        }
        // 支払い完了（クレジット払い）
        if (this.detail[0].status_code === 5 && this.detail[0].payment_method_code === 1) {
          this.nativePVset('CARCARE_CREDIT')
        }
      }
    // 予約がない場合
    } else {
      if (this.profileInfo.best_myss.length !== 0) {
        // 車検対応店舗
        if (this.ssInfo.komikomi_flag === 1) {
          this.nativePVset('CARCARE')
        // 車検非対応店舗
        } else {
          this.nativePVset('CARCARE_NOSERVICE')
        }
      }
    }
    if (!isApiError) {
      this.loading = false
    }
  },
  components: {
    CarCareTopInspectionBefore,
    CarCareTopInspectionAfter,
    Loading
  }
}

</script>
